import CollegeCourses from "../../components/CollegeCourses";


function Courses(){

return(

<div style={{marginTop:"80px"}}>

<h1 style={{textAlign:"center",marginTop:"100px"}}>Our Courses</h1>

<CollegeCourses/>



</div>

);

}

export default Courses;